import {NarcisWallHeader, usePageSearch} from '@product/narcis/wall/header'

type HeaderAccent = 'tools' | 'portrait' | 'packs' | 'pricing' | null

interface HeaderProps {
    variant?: 'overlay' | 'standard'
    accent?: HeaderAccent
}

/**
 * Every narcis page wears the wall's own header (search included), so the pack and tool pages read
 * as rooms of the same house as `/`. `variant` is accepted for call-site backward compat but unused
 * — the wall header has no overlay/standard distinction.
 */
const Header = ({accent}: HeaderProps) => {
    const pageSearch = usePageSearch()
    const door = accent === 'packs' || accent === 'tools' ? accent : null
    return <NarcisWallHeader accent={door} search={pageSearch} />
}

export {Header}
export type {HeaderAccent}
